import { useEffect } from "react";
import { Capacitor } from "@capacitor/core";
import { ScreenOrientation } from "@capacitor/screen-orientation";

const useScreenOrientation = () => {
  useEffect(() => {
    const lockToPortrait = async () => {
      if (!Capacitor.isNativePlatform() || !Capacitor.isPluginAvailable("ScreenOrientation")) {
        return;
      }

      try {
        await ScreenOrientation.lock({ orientation: "portrait" });
      } catch (err) {
        console.error("Не удалось установить ориентацию:", err);
      }
    };

    lockToPortrait();
  }, []);
};

export default useScreenOrientation;
